import { DEFAULT_LOCALE, type Locale } from "@/i18n/locales"
import { currencyFormatter } from "@/lib/money/currency-format"

const CURRENCY = "MXN"

export const money = (value: number, locale: Locale = DEFAULT_LOCALE) =>
  currencyFormatter({ locale, currency: CURRENCY, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)

export const moneyShort = (value: number, locale: Locale = DEFAULT_LOCALE) =>
  currencyFormatter({ locale, currency: CURRENCY, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value)

export const compactCount = (count: number) => (count >= 1000 ? `${(count / 1000).toFixed(1).replace(".0", "")}k` : String(count))
